import {observer} from "mobx-react";
import * as React from "react";
import {UIState} from "data/UIState";

@observer
export class AriaLiveRegion extends React.Component<any, {}> {

  render(){
    return (
      // 'aria-live="polite"' means the screen reader will wait until it finishes its current announcement to announce this one.
      // 'aria-atomic="true"' ensures the entire content of the region is announced even if only part of it changes.
      <div
        tabIndex={-1}
        id="aria-live-region"
        aria-live="polite"
        aria-atomic="true"
        className="visuallyhidden" // Class to hide it visually
        role="status" // Helps define the element's purpose
      >
        {UIState.ariaLiveAnnouncement}
      </div>
    );

  }
}